import { render, staticRenderFns } from "./UpComming.vue?vue&type=template&id=97a579be&scoped=true&"
import script from "./UpComming.vue?vue&type=script&lang=js&"
export * from "./UpComming.vue?vue&type=script&lang=js&"
import style0 from "./UpComming.vue?vue&type=style&index=0&id=97a579be&lang=less&scoped=true&"
import style1 from "./UpComming.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a579be",
  null
  
)

export default component.exports